module.exports = __webpack_public_path__ + "static/media/decoration-gray-bottom-2.ddcde2e1.svg";